import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var staticImageSchema = {
    name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидно име',
    }),
    image: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'image',
        label: 'Картинка',
        value: null,
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете картинка за слайда',
    }),
};
export default staticImageSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/staticImageSchema.ts
// module id = 475
// module chunks = 0